export function ReplaceIcon({ className }: { className?: string }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M17.0833 4.58398H7.91667C4.82227 4.58398 2.5 6.82151 2.5 10.0007"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.91669 15.4167H12.0834C15.1778 15.4167 17.5 13.1792 17.5 10"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.4167 2.5C15.4167 2.5 17.5 4.03435 17.5 4.58335C17.5 5.13235 15.4167 6.66667 15.4167 6.66667"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.58332 13.334C4.58332 13.334 2.50001 14.8683 2.5 15.4173C2.49999 15.9663 4.58333 17.5007 4.58333 17.5007"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
